import React, {useRef, useState} from "react";
import {Dialog, DialogActions, DialogContent, makeStyles, Typography} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import {useDispatch, useSelector} from "react-redux";
import {onCloseAvatarUpload} from "./uploadAvatar.slice";
import Button from "@material-ui/core/Button";
import {useDebounceEffect} from "./utils/useDebounceEffect";
import {canvasPreview} from "./utils/canvasPreview";
import {uploadFile} from "../../../jsonScreen.slice";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles(() => ({
    dialogContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    dialogTitle: {
        fontSize: 16
    }
}))
const UploadAvatarComponent = () => {
    const screenName = useSelector(state => state.jsonScreen.screenName)
    const isOpen = useSelector((state) => state.uploadAvatar.isOpen);
    const setToVar = useSelector((state) => state.uploadAvatar.setToVar);
    const initialFile = useSelector((state) => state.uploadAvatar.initialFile);

    //utils ref
    const imgRef = useRef(null)
    const previewCanvasRef = useRef(null)
    const blobUrlRef = useRef('')

    const classes = useStyles();
    const dispatch = useDispatch();
    const [crop, setCrop] = useState()
    // const [scale, setScale] = useState(1)
    // const [rotate, setRotate] = useState(0)
    const [aspect, setAspect] = useState(1)
    const [completedCrop, setCompletedCrop] = useState({})

    useDebounceEffect(
        async () => {
            if (
                completedCrop?.width &&
                completedCrop?.height &&
                imgRef.current &&
                previewCanvasRef.current
            ) {
                // We use canvasPreview as it's much faster than imgPreview.
                canvasPreview(
                    imgRef.current,
                    previewCanvasRef.current,
                    completedCrop,
                    1,
                    0,
                )
            }
        },
        100,
        [completedCrop],
    )

    async function onDownloadCropClick() {
        const image = imgRef.current
        const previewCanvas = previewCanvasRef.current
        if (!image || !previewCanvas || !completedCrop) {
            throw new Error('Crop canvas does not exist')
        }

        // This will size relative to the uploaded image
        // size. If you want to size according to what they
        // are looking at on screen, remove scaleX + scaleY
        const scaleX = image.naturalWidth / image.width
        const scaleY = image.naturalHeight / image.height

        const offscreen = new OffscreenCanvas(
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
        )
        const ctx = offscreen.getContext('2d')
        if (!ctx) {
            throw new Error('No 2d context')
        }

        ctx.drawImage(
            previewCanvas,
            0,
            0,
            previewCanvas.width,
            previewCanvas.height,
            0,
            0,
            offscreen.width,
            offscreen.height,
        )
        // You might want { type: "image/jpeg", quality: <0 to 1> } to
        // reduce image size
        const blob = await offscreen.convertToBlob({
            type: 'image/png',
        })

        if (blobUrlRef.current) {
            URL.revokeObjectURL(blobUrlRef.current)
        }
        blobUrlRef.current = URL.createObjectURL(blob)

        dispatch(uploadFile({
            action: {
                setToVar,
                param: [
                    {
                        value: [{
                            ...initialFile,
                            content: blobUrlRef.current
                        }]
                    }
                ]
            },
            screenName,
        }))
        dispatch(onCloseAvatarUpload());
        setCrop({})
    }

    return (
        <Dialog
            open={isOpen}
            onClose={() => dispatch(onCloseAvatarUpload())}
            fullWidth={true}
            maxWidth={'md'}
        >
            <DialogTitle>
                <Typography className={classes.dialogTitle}>Upload Avatar</Typography>
            </DialogTitle>
            <Divider/>
            <DialogContent>
                <div className={classes.dialogContainer}>
                    <ReactCrop
                        crop={crop}
                        aspect={aspect}
                        onChange={c => setCrop(c)}
                        onComplete={(c) => setCompletedCrop(c)}
                    >
                        <img ref={imgRef} style={{maxHeight: 300}} src={initialFile.content} alt={'for_crop_image'}/>
                    </ReactCrop>
                </div>
                <div style={{
                    position: 'absolute',
                    visibility: 'hidden',
                    top: '-200vh'
                }}>
                    <canvas
                        ref={previewCanvasRef}
                        style={{
                            border: '1px solid black',
                            objectFit: 'contain',
                            width: completedCrop.width,
                            height: completedCrop.height,
                        }}
                    />
                </div>
            </DialogContent>
            <Divider/>
            <DialogActions>
                <Button
                    onClick={onDownloadCropClick}
                    variant={'contained'} color={'primary'} size={'small'}>Apply</Button>
                <Button
                    onClick={() => dispatch(onCloseAvatarUpload())}
                    variant={'contained'} color={'default'} size={'small'}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default UploadAvatarComponent;